export function getLogoUrlFromOptions(): string | undefined {
  return window.APP_OPTIONS.logoUrl
}

export function getLogoMessageFromOptions(): string | undefined {
  return window.APP_OPTIONS.logoMessage
}
